import { Link } from "react-router-dom";

const Cancel = () => (
  <div data-testid="cancel-page" className="pt-32 pb-24 min-h-[80vh] flex items-start justify-center">
    <div className="max-w-xl w-full px-6 md:px-12 text-center">
      <div className="mx-auto inline-flex items-center justify-center w-16 h-16 border hairline mb-10">
        <img src="/mountain-mark.png" alt="" aria-hidden className="h-6 w-auto select-none" draggable={false} />
      </div>
      <h1 className="font-serif text-4xl md:text-5xl">Checkout cancelled</h1>
      <div className="divider-gold mx-auto mt-6 mb-6" />
      <p className="text-[var(--secondary-text)] leading-loose">
        Your order was not completed. Your cart remains intact — return when you're ready.
      </p>
      <div className="mt-12 flex items-center justify-center gap-4">
        <Link to="/" className="btn-secondary" data-testid="cancel-home-btn">
          Return Home
        </Link>
        <Link to="/ivory" className="btn-secondary" data-testid="cancel-shop-btn">
          Back to Ivory
        </Link>
      </div>
    </div>
  </div>
);

export default Cancel;
